import React from 'react'
import './Personalitytest.css'

export default function ErrorMessage(props) {
  return <p className="align-center errorMessage">{props.text}</p>
}